/** The Invisible Rescue — Magnetworks LER9468; Explorers 5–7.
 * Post-PR404 additive authored pages. All physical outcomes remain child-reported.
 * Existing seven Journeys are unchanged. Media copied from approved local MP4s.
 */
const MAGNETWORKS_PAGES = {
  "magnetworks-prelude": {
    "step_id": "magnetworks-prelude",
    "title": "The Invisible Rescue",
    "subtitle": "Pip is stranded. Find the mystery.",
    "phase": "Prelude",
    "story": "Pip must travel beside the wall without a hand pushing the car.",
    "age_band": "explorers_5_7",
    "self_guided": {
      "title": "The Invisible Rescue",
      "say": "Pip is stranded. Find the mystery.",
      "do_now": "Pip is stranded. Find the mystery.",
      "help_prompt": "Professor Swan: You are the calm, capable master teacher helping a 5–7-year-old investigate the REAL Learning Resources Magnetworks LER9468 (manufacturer 5+). Pip is the wheeled green car. Use the exact current activity and child's saved answers. One short spoken instruction or one diagnostic question at a time. The child must predict and report physical results; do not infer that Pip moved from a checkbox, picture, animation, or prior adult experiment. Treat 'stayed still', 'not sure', and 'stopped' as valid evidence. No fixed magnet-disc color means north or south. Keep the wall upright; car travels along one side of barrier, not through the cardboard. Where magnets are safely arranged, reversing the facing pole can change attraction/repulsion and motion direction, but actual results also depend on placement and friction. Before the child offers their own explanation, don't spoil the pole-direction discovery. Never demand that a 5-year-old loosen or swap small detachable magnets independently. Specific safety: this kit contains a small magnetic ball, small parts and detachable magnets; no mouthing, nose/ear use, or exposure to under-3 siblings; stop if a magnet is damaged or missing; adult handles small loose discs for car setup/reorientation and levitation. Avoid repetitive generic adult supervision. PWO 449 shows iron filings as a representation of field patterns, not a force-producing material. Optional PWO 450 is a *new* electromagnetism/motor topic; initial current slider is 0 mA, so ask child to move slider a little above zero to see motion, then back to zero. No motor or batteries in this physical Magnetworks kit.",
      "transition_summary": "You saved your thinking. We will use it in the next part.",
      "next_preview": "Another mystery is ready when you are.",
      "materials": [
        "Learning Resources STEM Explorers Magnetworks LER9468, age 5+",
        "Green magnetic wand and colored magnetic chips",
        "Green magnetic ball and thin, flat cardboard (optional maze)",
        "Green wheeled car, blue top, three disc magnets and supplied brick-pattern barrier card",
        "Purple magnetic stand and disc magnets (Grow)",
        "Flat clear tabletop and broad start/home markers"
      ],
      "parent_note": "The child leads thinking and tests. Help with loose magnets and cardboard cutting, and follow the manufacturer's warnings.",
      "caregiver_safety": [
        "Small magnetic ball, chips, and removable disc magnets are choking/ingestion hazards. Keep away from mouths, ears, noses and children under 3; account for all pieces after play.",
        "Do not use damaged/cracked magnets. If a magnet is swallowed or inhaled, seek urgent medical care; do not wait for symptoms.",
        "A grown-up prepares cardboard cutting and manages loose disc insertion, face changes or levitation stacking if needed. The child makes the predictions, uses the assembled wand, and reports observations."
      ]
    },
    "blocks": [
      {
        "id": "mw-story-video",
        "type": "story_prelude",
        "eyebrow": "THE INVISIBLE RESCUE",
        "title": "Pip Needs a Rescue",
        "prompt": "Watch the mystery. We have not solved it yet.",
        "master_teacher_watch": {
          "button": "Watch Pip’s mystery",
          "why": "Look for the problem Pip needs you to solve.",
          "after": "What is Pip trying to do? Want to watch again? Tap Watch Pip’s mystery to replay."
        },
        "video": {
          "title": "The Invisible Rescue",
          "path": "magnetworks/prelude/story_v1.mp4",
          "poster": "magnetworks/prelude/story_poster.jpg",
          "caption": "Pip needs help. Watch for the mystery, not the answer."
        },
        "reading": {
          "tab_label": "Read the mystery",
          "eyebrow": "PIP NEEDS HELP",
          "title": "Can Pip Get Home?",
          "content": [
            {
              "type": "paragraph",
              "text": "Pip is a little wheeled cart. HOME is the place you will choose for him to reach. Later, you will mark it with a little house drawing on the table."
            },
            {
              "type": "paragraph",
              "text": "The wall must stay up. Nobody may touch Pip while the cart moves. Can you investigate a way to bring Pip home?"
            },
            {
              "type": "question",
              "text": "What would you try first?"
            }
          ]
        }
      },
      {
        "id": "mw-mission-rule",
        "type": "choice_cards",
        "title": "What must stay true?",
        "prompt": "Pip needs to get home. Which rule makes this a no-touch rescue?",
        "save_as": "rescue_rule",
        "required": true,
        "choices": [
          {
            "id": "wall",
            "label": "The wall stays up. I must not push Pip with my hand."
          },
          {
            "id": "hands",
            "label": "I can move the wall and push Pip with my hand."
          },
          {
            "id": "not_sure",
            "label": "I am not sure yet."
          }
        ]
      },
      {
        "id": "mw-swan-prelude",
        "type": "saras_checkpoint",
        "title": "Ask Swan about the mission",
        "suggested_questions": [
          "How do I watch Pip’s mystery again?",
          "What is the rescue rule?"
        ],
        "hidden_context": "Professor Swan: You are the calm, capable master teacher helping a 5–7-year-old investigate the REAL Learning Resources Magnetworks LER9468 (manufacturer 5+). Pip is the wheeled green car. Use the exact current activity and child's saved answers. One short spoken instruction or one diagnostic question at a time. The child must predict and report physical results; do not infer that Pip moved from a checkbox, picture, animation, or prior adult experiment. Treat 'stayed still', 'not sure', and 'stopped' as valid evidence. No fixed magnet-disc color means north or south. Keep the wall upright; car travels along one side of barrier, not through the cardboard. Where magnets are safely arranged, reversing the facing pole can change attraction/repulsion and motion direction, but actual results also depend on placement and friction. Before the child offers their own explanation, don't spoil the pole-direction discovery. Never demand that a 5-year-old loosen or swap small detachable magnets independently. Specific safety: this kit contains a small magnetic ball, small parts and detachable magnets; no mouthing, nose/ear use, or exposure to under-3 siblings; stop if a magnet is damaged or missing; adult handles small loose discs for car setup/reorientation and levitation. Avoid repetitive generic adult supervision. PWO 449 shows iron filings as a representation of field patterns, not a force-producing material. Optional PWO 450 is a *new* electromagnetism/motor topic; initial current slider is 0 mA, so ask child to move slider a little above zero to see motion, then back to zero. No motor or batteries in this physical Magnetworks kit. Do not reveal magnet polarity or the car setup. IMPORTANT: If a child asks to hear or watch the mystery again, say: \"Tap Previous activity at the bottom, then tap Watch Pip’s mystery. Come back with Next activity.\" Do not treat the request to replay as a rescue-rule answer or evidence. Only the story and rule have been introduced; no physical experiment has occurred."
      },
      {
        "id": "mw-prelude-gate",
        "type": "completion_gate",
        "incomplete_title": "One clue left",
        "complete_title": "Your evidence is saved",
        "incomplete_prompt": "Choose the rescue rule.",
        "complete_prompt": "Your work is saved. You can continue.",
        "rules": [
          {
            "field": "rescue_rule",
            "condition": "answered"
          }
        ]
      }
    ]
  },
  "magnetworks-wonder": {
    "step_id": "magnetworks-wonder",
    "title": "What Could Move Pip?",
    "subtitle": "Make your first guess before testing.",
    "phase": "Wonder",
    "story": "The best first idea is one you can actually try.",
    "age_band": "explorers_5_7",
    "self_guided": {
      "title": "What Could Move Pip?",
      "say": "Make your first guess before testing.",
      "do_now": "Make your first guess before testing.",
      "help_prompt": "Professor Swan: You are the calm, capable master teacher helping a 5–7-year-old investigate the REAL Learning Resources Magnetworks LER9468 (manufacturer 5+). Pip is the wheeled green car. Use the exact current activity and child's saved answers. One short spoken instruction or one diagnostic question at a time. The child must predict and report physical results; do not infer that Pip moved from a checkbox, picture, animation, or prior adult experiment. Treat 'stayed still', 'not sure', and 'stopped' as valid evidence. No fixed magnet-disc color means north or south. Keep the wall upright; car travels along one side of barrier, not through the cardboard. Where magnets are safely arranged, reversing the facing pole can change attraction/repulsion and motion direction, but actual results also depend on placement and friction. Before the child offers their own explanation, don't spoil the pole-direction discovery. Never demand that a 5-year-old loosen or swap small detachable magnets independently. Specific safety: this kit contains a small magnetic ball, small parts and detachable magnets; no mouthing, nose/ear use, or exposure to under-3 siblings; stop if a magnet is damaged or missing; adult handles small loose discs for car setup/reorientation and levitation. Avoid repetitive generic adult supervision. PWO 449 shows iron filings as a representation of field patterns, not a force-producing material. Optional PWO 450 is a *new* electromagnetism/motor topic; initial current slider is 0 mA, so ask child to move slider a little above zero to see motion, then back to zero. No motor or batteries in this physical Magnetworks kit. At Wonder, the child has ONLY heard the story and made possible predictions. There has been NO physical magnetic trial. Never say \"you saw\", \"you tested\", \"you found\", or imply Pip moved. If summarizing, say \"you predicted\" or \"you wondered\" and invite the next hands-on investigation.",
      "transition_summary": "You saved your thinking. We will use it in the next part.",
      "next_preview": "Another mystery is ready when you are.",
      "materials": [
        "Learning Resources STEM Explorers Magnetworks LER9468, age 5+",
        "Green magnetic wand and colored magnetic chips",
        "Green magnetic ball and thin, flat cardboard (optional maze)",
        "Green wheeled car, blue top, three disc magnets and supplied brick-pattern barrier card",
        "Purple magnetic stand and disc magnets (Grow)",
        "Flat clear tabletop and broad start/home markers"
      ],
      "parent_note": "The child leads thinking and tests. Help with loose magnets and cardboard cutting, and follow the manufacturer's warnings.",
      "caregiver_safety": [
        "Small magnetic ball, chips, and removable disc magnets are choking/ingestion hazards. Keep away from mouths, ears, noses and children under 3; account for all pieces after play.",
        "Do not use damaged/cracked magnets. If a magnet is swallowed or inhaled, seek urgent medical care; do not wait for symptoms.",
        "A grown-up prepares cardboard cutting and manages loose disc insertion, face changes or levitation stacking if needed. The child makes the predictions, uses the assembled wand, and reports observations."
      ]
    },
    "blocks": [
      {
        "id": "mw-wonder-hook",
        "type": "story_hook",
        "title": "A strange challenge",
        "body": "You have not tried the real magnets yet. Before we test, look at the car, the green wand, and the wall. What do you think could help Pip move without a finger pushing it?",
        "master_teacher_briefing": {
          "title": "Let’s make a first guess",
          "steps": [
            "Look at the real car, green wand, and brick-pattern wall in the photo below.",
            "Think about how Pip might move without a finger pushing it.",
            "Choose an idea below. This is ONLY your prediction—we have not tested yet."
          ],
          "spoken": "Look at the green car, wand, and wall. We have not tested anything yet. What do you think might help Pip move without touching him? Choose your idea, even if you are unsure."
        }
      },
      {
        "id": "mw-meet-kit",
        "type": "image_gallery",
        "title": "Meet the three rescue tools",
        "prompt": "Look at the real car, green wand, and wall. We will test them later. For now, make a guess.",
        "images": [
          {
            "id": "mw-kit-photo",
            "label": "Your real Magnetworks pieces",
            "path": "magnetworks/references/IMG_4735.jpg",
            "caption": "The green car, wand, magnetic discs, and brick-pattern wall card from the kit.",
            "alt": "Photo of the actual Magnetworks car, green wand, magnetic discs and brick-pattern wall card on a table."
          }
        ]
      },
      {
        "id": "mw-first-idea",
        "type": "choice_cards",
        "title": "What might help?",
        "prompt": "Pick something you might try. This is a guess, not a test.",
        "save_as": "first_idea",
        "required": true,
        "choices": [
          {
            "id": "wand",
            "label": "Maybe the green wand"
          },
          {
            "id": "air",
            "label": "Maybe blowing air"
          },
          {
            "id": "something",
            "label": "Maybe something else"
          },
          {
            "id": "unsure",
            "label": "I do not know yet"
          }
        ],
        "master_teacher_response_kind": "prediction"
      },
      {
        "id": "mw-first-prediction",
        "type": "choice_cards",
        "title": "What might happen?",
        "prompt": "Before touching the kit, what do you think might happen when a tool comes near Pip?",
        "save_as": "first_prediction",
        "required": true,
        "choices": [
          {
            "id": "move",
            "label": "Pip may move"
          },
          {
            "id": "stay",
            "label": "Pip may stay still"
          },
          {
            "id": "unsure",
            "label": "Not sure yet"
          }
        ],
        "master_teacher_response_kind": "prediction"
      },
      {
        "id": "mw-swan-wonder",
        "type": "saras_checkpoint",
        "title": "Tell Swan your idea",
        "suggested_questions": [
          "Can I change my prediction later?",
          "How do I test without touching?"
        ],
        "hidden_context": "Professor Swan: You are the calm, capable master teacher helping a 5–7-year-old investigate the REAL Learning Resources Magnetworks LER9468 (manufacturer 5+). Pip is the wheeled green car. Use the exact current activity and child's saved answers. One short spoken instruction or one diagnostic question at a time. The child must predict and report physical results; do not infer that Pip moved from a checkbox, picture, animation, or prior adult experiment. Treat 'stayed still', 'not sure', and 'stopped' as valid evidence. No fixed magnet-disc color means north or south. Keep the wall upright; car travels along one side of barrier, not through the cardboard. Where magnets are safely arranged, reversing the facing pole can change attraction/repulsion and motion direction, but actual results also depend on placement and friction. Before the child offers their own explanation, don't spoil the pole-direction discovery. Never demand that a 5-year-old loosen or swap small detachable magnets independently. Specific safety: this kit contains a small magnetic ball, small parts and detachable magnets; no mouthing, nose/ear use, or exposure to under-3 siblings; stop if a magnet is damaged or missing; adult handles small loose discs for car setup/reorientation and levitation. Avoid repetitive generic adult supervision. PWO 449 shows iron filings as a representation of field patterns, not a force-producing material. Optional PWO 450 is a *new* electromagnetism/motor topic; initial current slider is 0 mA, so ask child to move slider a little above zero to see motion, then back to zero. No motor or batteries in this physical Magnetworks kit. Do not say which arrangement will work. The child has NOT used the physical kit in this Journey yet. All saved fields here are predictions only. Never preview success or a result. The next physical experiment is a small-chip investigation before the car."
      },
      {
        "id": "mw-wonder-gate",
        "type": "completion_gate",
        "incomplete_title": "One clue left",
        "complete_title": "Your evidence is saved",
        "incomplete_prompt": "Choose an idea and a prediction.",
        "complete_prompt": "Your work is saved. You can continue.",
        "rules": [
          {
            "field": "first_idea",
            "condition": "answered"
          },
          {
            "field": "first_prediction",
            "condition": "answered"
          }
        ]
      }
    ]
  },
  "magnetworks-explore": {
    "step_id": "magnetworks-explore",
    "title": "A Clue Without Touching",
    "subtitle": "Try the wand with a chip, then with a thin card.",
    "phase": "Explore",
    "story": "Investigate the invisible interaction before you try the cart.",
    "age_band": "explorers_5_7",
    "self_guided": {
      "title": "A Clue Without Touching",
      "say": "Try the wand with a chip, then with a thin card.",
      "do_now": "Try the wand with a chip, then with a thin card.",
      "help_prompt": "Professor Swan: You are the calm, capable master teacher helping a 5–7-year-old investigate the REAL Learning Resources Magnetworks LER9468 (manufacturer 5+). Pip is the wheeled green car. Use the exact current activity and child's saved answers. One short spoken instruction or one diagnostic question at a time. The child must predict and report physical results; do not infer that Pip moved from a checkbox, picture, animation, or prior adult experiment. Treat 'stayed still', 'not sure', and 'stopped' as valid evidence. No fixed magnet-disc color means north or south. Keep the wall upright; car travels along one side of barrier, not through the cardboard. Where magnets are safely arranged, reversing the facing pole can change attraction/repulsion and motion direction, but actual results also depend on placement and friction. Before the child offers their own explanation, don't spoil the pole-direction discovery. Never demand that a 5-year-old loosen or swap small detachable magnets independently. Specific safety: this kit contains a small magnetic ball, small parts and detachable magnets; no mouthing, nose/ear use, or exposure to under-3 siblings; stop if a magnet is damaged or missing; adult handles small loose discs for car setup/reorientation and levitation. Avoid repetitive generic adult supervision. PWO 449 shows iron filings as a representation of field patterns, not a force-producing material. Optional PWO 450 is a *new* electromagnetism/motor topic; initial current slider is 0 mA, so ask child to move slider a little above zero to see motion, then back to zero. No motor or batteries in this physical Magnetworks kit.",
      "transition_summary": "You saved your thinking. We will use it in the next part.",
      "next_preview": "Another mystery is ready when you are.",
      "materials": [
        "Learning Resources STEM Explorers Magnetworks LER9468, age 5+",
        "Green magnetic wand and colored magnetic chips",
        "Green magnetic ball and thin, flat cardboard (optional maze)",
        "Green wheeled car, blue top, three disc magnets and supplied brick-pattern barrier card",
        "Purple magnetic stand and disc magnets (Grow)",
        "Flat clear tabletop and broad start/home markers"
      ],
      "parent_note": "The child leads thinking and tests. Help with loose magnets and cardboard cutting, and follow the manufacturer's warnings.",
      "caregiver_safety": [
        "Small magnetic ball, chips, and removable disc magnets are choking/ingestion hazards. Keep away from mouths, ears, noses and children under 3; account for all pieces after play.",
        "Do not use damaged/cracked magnets. If a magnet is swallowed or inhaled, seek urgent medical care; do not wait for symptoms.",
        "A grown-up prepares cardboard cutting and manages loose disc insertion, face changes or levitation stacking if needed. The child makes the predictions, uses the assembled wand, and reports observations."
      ],
      "safety": [
        "Magnets and small pieces stay out of mouths, noses and ears. Keep them away from younger children. Stop if any magnet is loose or damaged."
      ]
    },
    "blocks": [
      {
        "id": "mw-chip-setup",
        "type": "story_hook",
        "title": "First, investigate your wand",
        "body": "Before we try to rescue Pip, let’s find out if the wand can make a tiny chip move without a finger touching it. This is a practice test for our no-touch rescue."
      },
      {
        "id": "mw-chip-trial",
        "type": "experiment_record",
        "title": "Try moving one chip",
        "prompt": "First try the steps below. Then tell Swan what you actually saw.",
        "save_as": "chip_trial",
        "master_teacher_response_kind": "reported_trial_result",
        "master_teacher_briefing": {
          "title": "First, try moving one chip",
          "steps": [
            "Find the green wand and one magnetic chip.",
            "Set the chip on a clear, flat table. Slowly bring the wand near the chip, but do not touch it.",
            "Watch the chip. Then choose what happened below."
          ],
          "spoken": "Before rescuing Pip, let’s try one tiny test. Put one magnetic chip on the table. Slowly bring the green wand close without touching the chip. Watch it, then tell me what happened."
        },
        "fields": [
          {
            "id": "result",
            "type": "choice",
            "label": "Now, what did your chip do?",
            "choices": [
              {
                "id": "moved",
                "label": "The chip moved"
              },
              {
                "id": "stayed",
                "label": "The chip stayed"
              },
              {
                "id": "touched",
                "label": "The wand touched it by mistake"
              },
              {
                "id": "not_tested",
                "label": "I could not safely test"
              }
            ]
          }
        ]
      },
      {
        "id": "mw-card-invite",
        "type": "story_hook",
        "title": "Could the wand work through cardboard?",
        "body": "This is a prediction, not the cardboard test. You will try it in the next part.",
        "master_teacher_briefing": {
          "title": "First, imagine a wall between them",
          "steps": [
            "Imagine your tiny chip on TOP of a thin sheet of cardboard.",
            "Imagine holding the wand UNDER the cardboard, so the wand cannot touch the chip.",
            "Choose your prediction below. Then go to the next part to try it."
          ],
          "spoken": "Now imagine your wand under the cardboard, with the chip on top. The wand cannot touch the chip. Do you think the chip could still move? Make your guess first. In the next part, you will try it."
        }
      },
      {
        "id": "mw-card-prediction",
        "type": "choice_cards",
        "title": "What about a card?",
        "prompt": "Imagine putting the thin cardboard between your wand and a chip. Do you think the chip could still move? First make your guess; test afterward.",
        "save_as": "card_prediction",
        "required": true,
        "choices": [
          {
            "id": "still",
            "label": "It can still move"
          },
          {
            "id": "stop",
            "label": "It will stay still"
          },
          {
            "id": "unsure",
            "label": "I do not know"
          }
        ],
        "master_teacher_response_kind": "prediction"
      },
      {
        "id": "mw-card-trial",
        "type": "experiment_record",
        "title": "Try the wand through cardboard",
        "prompt": "Try the steps below first. Then choose what you saw.",
        "save_as": "card_trial",
        "master_teacher_response_kind": "reported_trial_result",
        "master_teacher_briefing": {
          "title": "Now test the cardboard mystery",
          "steps": [
            "Place the thin cardboard flat on a table with one chip on top.",
            "Hold your green wand UNDER the cardboard, across from the chip. Move it slowly without touching the chip.",
            "Look at the chip on top. Did it follow the wand? Choose what you saw."
          ],
          "spoken": "You moved the wand near a chip. Now can you move the chip with a piece of cardboard between them? Put the chip on top of the cardboard, hold the wand underneath, and gently move it. What did the chip do?"
        },
        "fields": [
          {
            "id": "result",
            "type": "choice",
            "label": "What did the chip do when the cardboard was between them?",
            "choices": [
              {
                "id": "moved",
                "label": "It moved across the card"
              },
              {
                "id": "stayed",
                "label": "It did not move"
              },
              {
                "id": "touch",
                "label": "I accidentally touched it"
              },
              {
                "id": "not_tested",
                "label": "I could not safely test"
              }
            ]
          }
        ]
      },
      {
        "id": "mw-swan-explore",
        "type": "saras_checkpoint",
        "title": "Need a clue?",
        "suggested_questions": [
          "What if nothing moves?",
          "What if the wand touched it?"
        ],
        "hidden_context": "Professor Swan: You are the calm, capable master teacher helping a 5–7-year-old investigate the REAL Learning Resources Magnetworks LER9468 (manufacturer 5+). Pip is the wheeled green car. Use the exact current activity and child's saved answers. One short spoken instruction or one diagnostic question at a time. The child must predict and report physical results; do not infer that Pip moved from a checkbox, picture, animation, or prior adult experiment. Treat 'stayed still', 'not sure', and 'stopped' as valid evidence. No fixed magnet-disc color means north or south. Keep the wall upright; car travels along one side of barrier, not through the cardboard. Where magnets are safely arranged, reversing the facing pole can change attraction/repulsion and motion direction, but actual results also depend on placement and friction. Before the child offers their own explanation, don't spoil the pole-direction discovery. Never demand that a 5-year-old loosen or swap small detachable magnets independently. Specific safety: this kit contains a small magnetic ball, small parts and detachable magnets; no mouthing, nose/ear use, or exposure to under-3 siblings; stop if a magnet is damaged or missing; adult handles small loose discs for car setup/reorientation and levitation. Avoid repetitive generic adult supervision. PWO 449 shows iron filings as a representation of field patterns, not a force-producing material. Optional PWO 450 is a *new* electromagnetism/motor topic; initial current slider is 0 mA, so ask child to move slider a little above zero to see motion, then back to zero. No motor or batteries in this physical Magnetworks kit. Choose only one check: gap, surface, or alignment. Never infer success. Explain that these simple practice tests help Pip: we first explore whether the wand can affect a smaller item, then the real car-and-wall rescue comes in Apply. Spoken action must come BEFORE a request for results."
      },
      {
        "id": "mw-explore-gate",
        "type": "completion_gate",
        "incomplete_title": "One clue left",
        "complete_title": "Your evidence is saved",
        "incomplete_prompt": "Record both trials, including any not-tested outcome.",
        "complete_prompt": "Your work is saved. You can continue.",
        "rules": [
          {
            "field": "chip_trial",
            "condition": "record_complete"
          },
          {
            "field": "card_prediction",
            "condition": "answered"
          },
          {
            "field": "card_trial",
            "condition": "record_complete"
          }
        ]
      }
    ]
  },
  "magnetworks-understand": {
    "step_id": "magnetworks-understand",
    "title": "What Is the Invisible Clue?",
    "subtitle": "Use the evidence you really observed.",
    "phase": "Understand",
    "story": "Magnets may act across a gap, but first follow your own results.",
    "age_band": "explorers_5_7",
    "self_guided": {
      "title": "What Is the Invisible Clue?",
      "say": "Look back at your chip and cardboard reports. What can you say from what really happened?",
      "do_now": "Read your two reports, then choose what you noticed and what you would try next.",
      "help_prompt": "Professor Swan: You are the calm, capable master teacher helping a 5–7-year-old investigate the REAL Learning Resources Magnetworks LER9468 (manufacturer 5+). Pip is the wheeled green car. Use the exact current activity and child's saved answers. One short spoken instruction or one diagnostic question at a time. The child must predict and report physical results; do not infer that Pip moved from a checkbox, picture, animation, or prior adult experiment. Treat 'stayed still', 'not sure', and 'stopped' as valid evidence. No fixed magnet-disc color means north or south. Keep the wall upright; car travels along one side of barrier, not through the cardboard. Where magnets are safely arranged, reversing the facing pole can change attraction/repulsion and motion direction, but actual results also depend on placement and friction. Before the child offers their own explanation, don't spoil the pole-direction discovery. Never demand that a 5-year-old loosen or swap small detachable magnets independently. Specific safety: this kit contains a small magnetic ball, small parts and detachable magnets; no mouthing, nose/ear use, or exposure to under-3 siblings; stop if a magnet is damaged or missing; adult handles small loose discs for car setup/reorientation and levitation. Avoid repetitive generic adult supervision. PWO 449 shows iron filings as a representation of field patterns, not a force-producing material. Optional PWO 450 is a *new* electromagnetism/motor topic; initial current slider is 0 mA, so ask child to move slider a little above zero to see motion, then back to zero. No motor or batteries in this physical Magnetworks kit.",
      "transition_summary": "You looked at the evidence you recorded and made a new prediction.",
      "next_preview": "Another mystery is ready when you are.",
      "materials": [
        "Learning Resources STEM Explorers Magnetworks LER9468, age 5+",
        "Green magnetic wand and colored magnetic chips",
        "Green magnetic ball and thin, flat cardboard (optional maze)",
        "Green wheeled car, blue top, three disc magnets and supplied brick-pattern barrier card",
        "Purple magnetic stand and disc magnets (Grow)",
        "Flat clear tabletop and broad start/home markers"
      ],
      "parent_note": "The child leads thinking and tests. Help with loose magnets and cardboard cutting, and follow the manufacturer's warnings.",
      "caregiver_safety": [
        "Small magnetic ball, chips, and removable disc magnets are choking/ingestion hazards. Keep away from mouths, ears, noses and children under 3; account for all pieces after play.",
        "Do not use damaged/cracked magnets. If a magnet is swallowed or inhaled, seek urgent medical care; do not wait for symptoms.",
        "A grown-up prepares cardboard cutting and manages loose disc insertion, face changes or levitation stacking if needed. The child makes the predictions, uses the assembled wand, and reports observations."
      ]
    },
    "blocks": [
      {
        "id": "mw-explore-recall",
        "type": "prior_work_summary",
        "title": "What happened in your two small tests?",
        "items": [
          {
            "source_step_id": "magnetworks-explore",
            "field": "chip_trial",
            "label": "Chip test"
          },
          {
            "source_step_id": "magnetworks-explore",
            "field": "card_trial",
            "label": "Card test"
          }
        ]
      },
      {
        "id": "mw-contact-claim",
        "type": "choice_cards",
        "title": "What can you say from your test?",
        "prompt": "Look at the chip and cardboard reports. Which statement fits what you actually observed—even if nothing moved or you could not test?",
        "save_as": "gap_evidence",
        "required": true,
        "choices": [
          {
            "id": "gap",
            "label": "Something moved with a gap"
          },
          {
            "id": "stayed",
            "label": "Nothing moved in my test"
          },
          {
            "id": "touched",
            "label": "The wand touched my piece"
          },
          {
            "id": "unsure",
            "label": "I still need another test"
          }
        ]
      },
      {
        "id": "mw-distance-predict",
        "type": "choice_cards",
        "title": "What might happen if the wand is closer?",
        "prompt": "This is a prediction, not a new physical test. If you could move the wand a little closer, what do you think might happen?",
        "save_as": "distance_prediction",
        "required": true,
        "choices": [
          {
            "id": "more",
            "label": "The piece may move more easily"
          },
          {
            "id": "less",
            "label": "It may move less easily"
          },
          {
            "id": "same",
            "label": "Nothing may change"
          },
          {
            "id": "unsure",
            "label": "I want to try it"
          }
        ],
        "master_teacher_response_kind": "prediction"
      },
      {
        "id": "mw-swan-understand",
        "type": "saras_checkpoint",
        "title": "Ask Swan about invisible forces",
        "suggested_questions": [
          "How can something move without touching?",
          "What if my test did not work?"
        ],
        "hidden_context": "Professor Swan: You are the calm, capable master teacher helping a 5–7-year-old investigate the REAL Learning Resources Magnetworks LER9468 (manufacturer 5+). Pip is the wheeled green car. Use the exact current activity and child's saved answers. One short spoken instruction or one diagnostic question at a time. The child must predict and report physical results; do not infer that Pip moved from a checkbox, picture, animation, or prior adult experiment. Treat 'stayed still', 'not sure', and 'stopped' as valid evidence. No fixed magnet-disc color means north or south. Keep the wall upright; car travels along one side of barrier, not through the cardboard. Where magnets are safely arranged, reversing the facing pole can change attraction/repulsion and motion direction, but actual results also depend on placement and friction. Before the child offers their own explanation, don't spoil the pole-direction discovery. Never demand that a 5-year-old loosen or swap small detachable magnets independently. Specific safety: this kit contains a small magnetic ball, small parts and detachable magnets; no mouthing, nose/ear use, or exposure to under-3 siblings; stop if a magnet is damaged or missing; adult handles small loose discs for car setup/reorientation and levitation. Avoid repetitive generic adult supervision. PWO 449 shows iron filings as a representation of field patterns, not a force-producing material. Optional PWO 450 is a *new* electromagnetism/motor topic; initial current slider is 0 mA, so ask child to move slider a little above zero to see motion, then back to zero. No motor or batteries in this physical Magnetworks kit. Name attraction or repulsion only when appropriate to the report. A nonmagnetic barrier is not universally irrelevant. In Understand, look only at chip_trial and card_trial. A choice saying nothing moved or not tested is evidence, not a failure. The distance question is a NEW prediction only; do not claim the child has already tested a closer wand. Do not imply the car has moved yet."
      },
      {
        "id": "mw-understand-gate",
        "type": "completion_gate",
        "incomplete_title": "One clue left",
        "complete_title": "Your evidence is saved",
        "incomplete_prompt": "Select your evidence and next prediction.",
        "complete_prompt": "Your work is saved. You can continue.",
        "rules": [
          {
            "field": "gap_evidence",
            "condition": "answered"
          },
          {
            "field": "distance_prediction",
            "condition": "answered"
          }
        ]
      }
    ]
  },
  "magnetworks-apply": {
    "step_id": "magnetworks-apply",
    "title": "Can You Rescue Pip?",
    "subtitle": "Build the car’s safe setup and try the barrier challenge.",
    "phase": "Apply",
    "story": "The child uses evidence from the chip test to control a different object.",
    "age_band": "explorers_5_7",
    "self_guided": {
      "title": "Can You Rescue Pip?",
      "say": "Find Pip the green car, the brick wall, and your wand. Set up the rescue before you guess what might happen.",
      "do_now": "Set up car, upright wall, and wand. Make a prediction. Then try one careful no-touch rescue.",
      "help_prompt": "Professor Swan: You are the calm, capable master teacher helping a 5–7-year-old investigate the REAL Learning Resources Magnetworks LER9468 (manufacturer 5+). Pip is the wheeled green car. Use the exact current activity and child's saved answers. One short spoken instruction or one diagnostic question at a time. The child must predict and report physical results; do not infer that Pip moved from a checkbox, picture, animation, or prior adult experiment. Treat 'stayed still', 'not sure', and 'stopped' as valid evidence. No fixed magnet-disc color means north or south. Keep the wall upright; car travels along one side of barrier, not through the cardboard. Where magnets are safely arranged, reversing the facing pole can change attraction/repulsion and motion direction, but actual results also depend on placement and friction. Before the child offers their own explanation, don't spoil the pole-direction discovery. Never demand that a 5-year-old loosen or swap small detachable magnets independently. Specific safety: this kit contains a small magnetic ball, small parts and detachable magnets; no mouthing, nose/ear use, or exposure to under-3 siblings; stop if a magnet is damaged or missing; adult handles small loose discs for car setup/reorientation and levitation. Avoid repetitive generic adult supervision. PWO 449 shows iron filings as a representation of field patterns, not a force-producing material. Optional PWO 450 is a *new* electromagnetism/motor topic; initial current slider is 0 mA, so ask child to move slider a little above zero to see motion, then back to zero. No motor or batteries in this physical Magnetworks kit.",
      "transition_summary": "You reported your first rescue attempt—even if Pip stayed still or you did not test.",
      "next_preview": "Another mystery is ready when you are.",
      "materials": [
        "Learning Resources STEM Explorers Magnetworks LER9468, age 5+",
        "Green magnetic wand and colored magnetic chips",
        "Green magnetic ball and thin, flat cardboard (optional maze)",
        "Green wheeled car, blue top, three disc magnets and supplied brick-pattern barrier card",
        "Purple magnetic stand and disc magnets (Grow)",
        "Flat clear tabletop and broad start/home markers"
      ],
      "parent_note": "The child leads thinking and tests. Help with loose magnets and cardboard cutting, and follow the manufacturer's warnings.",
      "caregiver_safety": [
        "Small magnetic ball, chips, and removable disc magnets are choking/ingestion hazards. Keep away from mouths, ears, noses and children under 3; account for all pieces after play.",
        "Do not use damaged/cracked magnets. If a magnet is swallowed or inhaled, seek urgent medical care; do not wait for symptoms.",
        "A grown-up prepares cardboard cutting and manages loose disc insertion, face changes or levitation stacking if needed. The child makes the predictions, uses the assembled wand, and reports observations."
      ]
    },
    "blocks": [
      {
        "id": "mw-car-setup",
        "type": "story_hook",
        "title": "Build Pip’s real rescue course",
        "body": "Before we move Pip, let’s make a real rescue course. HOME is a spot you choose on the table—not another piece from the kit. Mark it with a little house drawing, then build your wall and car setup.",
        "master_teacher_briefing": {
          "title": "Set up Pip’s rescue course",
          "steps": [
            "Draw a little house on a scrap of paper. Put it at one end of the table: that is Pip’s HOME, the place he is trying to reach.",
            "Stand the brick-pattern wall upright. Place Pip a short distance from HOME, with both Pip and the house on ONE side of the wall. Keep the green wand on the OTHER side.",
            "Check that Pip’s wheels can roll and the magnets are secure. Stop and get help with loose magnets before testing."
          ],
          "spoken": "Time to build Pip’s rescue course. Make a little house drawing and place it on the table. That spot is HOME. Put Pip a short distance away on the same side of the brick wall. Your green wand stays on the other side. Check Pip’s wheels and magnets before trying to move him."
        }
      },
      {
        "id": "mw-car-photos",
        "type": "image_gallery",
        "title": "Match your real kit to the setup",
        "prompt": "These are actual Magnetworks kit photographs, not an animation of success.",
        "images": [
          {
            "id": "car",
            "label": "Pieces before setup",
            "path": "magnetworks/references/IMG_4735.jpg",
            "alt": "Green wheeled cart, magnetic wand, disc magnets and brick-pattern barrier"
          },
          {
            "id": "loaded",
            "label": "Three discs in the real car",
            "path": "magnetworks/references/IMG_4736.jpg",
            "alt": "Open green wheeled car with three colored magnetic discs placed in its compartments"
          },
          {
            "id": "wall",
            "label": "The wall between wand and car",
            "path": "magnetworks/references/IMG_4740.jpg",
            "alt": "Real green car and green wand on opposite sides of the upright brick-pattern barrier card"
          }
        ]
      },
      {
        "id": "mw-car-readiness",
        "type": "choice_cards",
        "title": "What is ready?",
        "prompt": "Look at the real car and wall before the test. Is the wall upright, and are Pip’s wheels and magnets secure?",
        "save_as": "car_readiness",
        "required": true,
        "choices": [
          {
            "id": "ready",
            "label": "My setup is ready for a careful test"
          },
          {
            "id": "help",
            "label": "Something is loose or I need to check a part"
          },
          {
            "id": "not_today",
            "label": "We cannot safely test today"
          }
        ]
      },
      {
        "id": "mw-car-predict",
        "type": "choice_cards",
        "title": "Which way might Pip go?",
        "prompt": "HOME means the house marker you placed on the table. If you move the wand along YOUR side of the wall, will Pip roll toward the house, away from it, or stay still? Guess before testing.",
        "save_as": "car_prediction",
        "required": true,
        "choices": [
          {
            "id": "home",
            "label": "Toward HOME"
          },
          {
            "id": "away",
            "label": "Away from HOME"
          },
          {
            "id": "stay",
            "label": "It may not move"
          },
          {
            "id": "unsure",
            "label": "I am unsure"
          }
        ],
        "master_teacher_response_kind": "prediction"
      },
      {
        "id": "mw-car-trial",
        "type": "experiment_record",
        "title": "Try rescuing Pip — first run",
        "prompt": "Use the big steps first. Then tell Swan what really happened.",
        "save_as": "car_trial_a",
        "master_teacher_response_kind": "reported_trial_result",
        "master_teacher_briefing": {
          "title": "Now it’s time to move Pip",
          "steps": [
            "Put Pip at START, a short distance from your HOME drawing. Keep Pip and HOME on one side of the upright brick-pattern wall, with the wand on the other side.",
            "Move the wand slowly along your side of the wall toward HOME. Do not touch Pip or knock the wall down.",
            "Watch where Pip rolls. Then choose what happened. If the car is not ready, choose Not tested."
          ],
          "spoken": "Now for the rescue. HOME is your house drawing. Put Pip a little way from HOME, with the upright wall between the car and your wand. Move the wand slowly toward HOME on your side of the wall. Watch whether Pip moves toward the house, away from it, or not at all. Tell me what you see."
        },
        "fields": [
          {
            "id": "direction",
            "type": "choice",
            "label": "After your test, which way did Pip really move?",
            "choices": [
              {
                "id": "home",
                "label": "Moved toward HOME"
              },
              {
                "id": "away",
                "label": "Moved away from HOME"
              },
              {
                "id": "still",
                "label": "Stayed still"
              },
              {
                "id": "mixed",
                "label": "Moved in a surprising way"
              },
              {
                "id": "not_tested",
                "label": "We did not test safely"
              }
            ]
          },
          {
            "id": "contact",
            "type": "choice",
            "label": "Was there a touch?",
            "choices": [
              {
                "id": "no",
                "label": "No touch between wand and car"
              },
              {
                "id": "yes",
                "label": "Something touched"
              },
              {
                "id": "unsure",
                "label": "I could not tell"
              }
            ]
          }
        ]
      },
      {
        "id": "mw-swan-apply",
        "type": "saras_checkpoint",
        "title": "Troubleshoot with Swan",
        "suggested_questions": [
          "Pip did not move. What is one thing to check?",
          "Why did it go away from HOME?"
        ],
        "hidden_context": "Professor Swan: You are the calm, capable master teacher helping a 5–7-year-old investigate the REAL Learning Resources Magnetworks LER9468 (manufacturer 5+). Pip is the wheeled green car. Use the exact current activity and child's saved answers. One short spoken instruction or one diagnostic question at a time. The child must predict and report physical results; do not infer that Pip moved from a checkbox, picture, animation, or prior adult experiment. Treat 'stayed still', 'not sure', and 'stopped' as valid evidence. No fixed magnet-disc color means north or south. Keep the wall upright; car travels along one side of barrier, not through the cardboard. Where magnets are safely arranged, reversing the facing pole can change attraction/repulsion and motion direction, but actual results also depend on placement and friction. Before the child offers their own explanation, don't spoil the pole-direction discovery. Never demand that a 5-year-old loosen or swap small detachable magnets independently. Specific safety: this kit contains a small magnetic ball, small parts and detachable magnets; no mouthing, nose/ear use, or exposure to under-3 siblings; stop if a magnet is damaged or missing; adult handles small loose discs for car setup/reorientation and levitation. Avoid repetitive generic adult supervision. PWO 449 shows iron filings as a representation of field patterns, not a force-producing material. Optional PWO 450 is a *new* electromagnetism/motor topic; initial current slider is 0 mA, so ask child to move slider a little above zero to see motion, then back to zero. No motor or batteries in this physical Magnetworks kit. If readiness is help/not_today, do not instruct actual trial; use the not_tested record. For a weak result: first check gap/wheels/secure discs separately. Child must have the assembled car, upright brick-pattern wall between them and car, and wand on the other side. Give the physical setup FIRST, then the movement action, then ask for observation. No claim of moving until the child reports it. If car_readiness is help or not_today, do not urge an experiment: guide one safe check or let the child select not_tested. The first trial is not proof of successful motion; trust car_trial_a direction and contact values. IMPORTANT: If car_trial_a.contact is yes, the child reported that something touched; do not call it a no-touch demonstration or infer magnetic attraction merely because direction was toward HOME. Separate reported direction from possible physical contact. If orientation and test conditions are uncertain, do not claim repulsion from an away result either."
      },
      {
        "id": "mw-apply-gate",
        "type": "completion_gate",
        "incomplete_title": "One clue left",
        "complete_title": "Your evidence is saved",
        "incomplete_prompt": "Report the first attempt, including if it was unsafe or not tested.",
        "complete_prompt": "Your work is saved. You can continue.",
        "rules": [
          {
            "field": "car_readiness",
            "condition": "answered"
          },
          {
            "field": "car_prediction",
            "condition": "answered"
          },
          {
            "field": "car_trial_a",
            "condition": "record_complete"
          }
        ]
      }
    ]
  },
  "magnetworks-test-improve": {
    "step_id": "magnetworks-test-improve",
    "title": "Can You Change Pip’s Direction?",
    "subtitle": "Choose one change and run a fair second trial.",
    "phase": "Test & Improve",
    "story": "Compare outcomes: a change in magnetic facing can affect movement.",
    "age_band": "explorers_5_7",
    "self_guided": {
      "title": "Can You Change Pip’s Direction?",
      "say": "Look at your first report. Choose just one thing to change—or choose to stop safely.",
      "do_now": "Choose one change, make a prediction, then run a second test or record that you could not test.",
      "help_prompt": "Professor Swan: You are the calm, capable master teacher helping a 5–7-year-old investigate the REAL Learning Resources Magnetworks LER9468 (manufacturer 5+). Pip is the wheeled green car. Use the exact current activity and child's saved answers. One short spoken instruction or one diagnostic question at a time. The child must predict and report physical results; do not infer that Pip moved from a checkbox, picture, animation, or prior adult experiment. Treat 'stayed still', 'not sure', and 'stopped' as valid evidence. No fixed magnet-disc color means north or south. Keep the wall upright; car travels along one side of barrier, not through the cardboard. Where magnets are safely arranged, reversing the facing pole can change attraction/repulsion and motion direction, but actual results also depend on placement and friction. Before the child offers their own explanation, don't spoil the pole-direction discovery. Never demand that a 5-year-old loosen or swap small detachable magnets independently. Specific safety: this kit contains a small magnetic ball, small parts and detachable magnets; no mouthing, nose/ear use, or exposure to under-3 siblings; stop if a magnet is damaged or missing; adult handles small loose discs for car setup/reorientation and levitation. Avoid repetitive generic adult supervision. PWO 449 shows iron filings as a representation of field patterns, not a force-producing material. Optional PWO 450 is a *new* electromagnetism/motor topic; initial current slider is 0 mA, so ask child to move slider a little above zero to see motion, then back to zero. No motor or batteries in this physical Magnetworks kit.",
      "transition_summary": "You compared what you recorded. A surprising result or a stopped test still gives you something to think about.",
      "next_preview": "Another mystery is ready when you are.",
      "materials": [
        "Learning Resources STEM Explorers Magnetworks LER9468, age 5+",
        "Green magnetic wand and colored magnetic chips",
        "Green magnetic ball and thin, flat cardboard (optional maze)",
        "Green wheeled car, blue top, three disc magnets and supplied brick-pattern barrier card",
        "Purple magnetic stand and disc magnets (Grow)",
        "Flat clear tabletop and broad start/home markers"
      ],
      "parent_note": "The child leads thinking and tests. Help with loose magnets and cardboard cutting, and follow the manufacturer's warnings.",
      "caregiver_safety": [
        "Small magnetic ball, chips, and removable disc magnets are choking/ingestion hazards. Keep away from mouths, ears, noses and children under 3; account for all pieces after play.",
        "Do not use damaged/cracked magnets. If a magnet is swallowed or inhaled, seek urgent medical care; do not wait for symptoms.",
        "A grown-up prepares cardboard cutting and manages loose disc insertion, face changes or levitation stacking if needed. The child makes the predictions, uses the assembled wand, and reports observations."
      ]
    },
    "blocks": [
      {
        "id": "mw-trial-a-recall",
        "type": "prior_work_summary",
        "title": "Your first car report",
        "items": [
          {
            "source_step_id": "magnetworks-apply",
            "field": "car_trial_a",
            "label": "Trial 1 result"
          }
        ]
      },
      {
        "id": "mw-choose-change",
        "type": "choice_cards",
        "title": "Choose one thing to change",
        "prompt": "For a fair second try, change just ONE thing. You can also choose not to test again.",
        "save_as": "one_change",
        "required": true,
        "choices": [
          {
            "id": "face",
            "label": "Change which magnetic face points toward Pip; get help if a loose magnet needs turning"
          },
          {
            "id": "gap",
            "label": "Keep the magnets as they are; hold the wand a little closer to the wall"
          },
          {
            "id": "pause",
            "label": "Stop here and use the evidence I already have"
          }
        ],
        "master_teacher_response_kind": "planned_change"
      },
      {
        "id": "mw-second-predict",
        "type": "choice_cards",
        "title": "Predict what will happen next",
        "prompt": "Before trying again, what do you think might happen? If you cannot test, it is fine to be unsure.",
        "save_as": "trial_b_prediction",
        "required": true,
        "choices": [
          {
            "id": "reverse",
            "label": "Opposite direction"
          },
          {
            "id": "same",
            "label": "Same direction"
          },
          {
            "id": "still",
            "label": "No movement"
          },
          {
            "id": "unsure",
            "label": "Not sure"
          }
        ],
        "master_teacher_response_kind": "prediction"
      },
      {
        "id": "mw-fair-test",
        "type": "story_hook",
        "title": "One change, one comparison",
        "body": "For a fair comparison, start Pip in the same place and move the wand the same way. Change only the one thing you chose. If you chose to stop, leave the magnets alone and record Not tested next."
      },
      {
        "id": "mw-second-trial",
        "type": "experiment_record",
        "title": "Try your second rescue run",
        "prompt": "First follow these steps—or choose Not tested if you stopped safely. Then report the result.",
        "save_as": "car_trial_b",
        "master_teacher_response_kind": "reported_trial_result",
        "master_teacher_briefing": {
          "title": "Try one change with Pip",
          "steps": [
            "If you chose to stop, leave the kit as it is and choose Not tested below.",
            "Otherwise, put Pip and the upright wall in the same starting places. If you chose distance, bring the wand a little closer. If you chose a magnetic face, get help with loose magnets.",
            "Move the wand slowly along your side of the wall, just like before. Watch Pip, then report what really happened."
          ],
          "spoken": "Time for test two. If you chose to stop, select Not tested. Otherwise, reset Pip and the wall. Change just one thing. Move the wand slowly in the same way, then tell me what Pip really did."
        },
        "fields": [
          {
            "id": "direction",
            "type": "choice",
            "label": "What did Pip actually do?",
            "choices": [
              {
                "id": "home",
                "label": "Moved toward HOME"
              },
              {
                "id": "away",
                "label": "Moved away from HOME"
              },
              {
                "id": "still",
                "label": "Stayed still"
              },
              {
                "id": "mixed",
                "label": "It moved unpredictably"
              },
              {
                "id": "not_tested",
                "label": "We did not test today"
              }
            ]
          }
        ]
      },
      {
        "id": "mw-compare-trials",
        "type": "choice_cards",
        "title": "Compare your two trials",
        "prompt": "Think about your two recorded results. Did Pip move the same way, a different way, or were you unable to compare two tests?",
        "save_as": "trial_comparison",
        "required": true,
        "choices": [
          {
            "id": "opposite",
            "label": "Pip went opposite ways"
          },
          {
            "id": "same",
            "label": "It went the same way"
          },
          {
            "id": "different",
            "label": "Something else changed or was unclear"
          },
          {
            "id": "not_tested",
            "label": "I could not compare two safe tests"
          }
        ]
      },
      {
        "id": "mw-swan-improve",
        "type": "saras_checkpoint",
        "title": "Ask Swan how to compare",
        "suggested_questions": [
          "How do I keep the test fair?",
          "Why might the result change?"
        ],
        "hidden_context": "Professor Swan: You are the calm, capable master teacher helping a 5–7-year-old investigate the REAL Learning Resources Magnetworks LER9468 (manufacturer 5+). Pip is the wheeled green car. Use the exact current activity and child's saved answers. One short spoken instruction or one diagnostic question at a time. The child must predict and report physical results; do not infer that Pip moved from a checkbox, picture, animation, or prior adult experiment. Treat 'stayed still', 'not sure', and 'stopped' as valid evidence. No fixed magnet-disc color means north or south. Keep the wall upright; car travels along one side of barrier, not through the cardboard. Where magnets are safely arranged, reversing the facing pole can change attraction/repulsion and motion direction, but actual results also depend on placement and friction. Before the child offers their own explanation, don't spoil the pole-direction discovery. Never demand that a 5-year-old loosen or swap small detachable magnets independently. Specific safety: this kit contains a small magnetic ball, small parts and detachable magnets; no mouthing, nose/ear use, or exposure to under-3 siblings; stop if a magnet is damaged or missing; adult handles small loose discs for car setup/reorientation and levitation. Avoid repetitive generic adult supervision. PWO 449 shows iron filings as a representation of field patterns, not a force-producing material. Optional PWO 450 is a *new* electromagnetism/motor topic; initial current slider is 0 mA, so ask child to move slider a little above zero to see motion, then back to zero. No motor or batteries in this physical Magnetworks kit. Do not promise reversal; check orientation, distance, wheel friction and the child report one at a time. If one_change is pause or either car_trial_a/car_trial_b is not_tested, DO NOT claim two experiments occurred. Explain that choosing Not tested is an acceptable record. For a fair trial with one_change=face, clarify the exact safe magnetic orientation before testing; do not assume the child must dismantle the car. Avoid promising reversal. A reported contact=yes means something touched: do NOT claim this first run proved no-touch attraction. Toward HOME is a direction report, not automatic proof of attraction. An away result alone is not proof of repulsion. Respond to both results accurately, and suggest one fair no-touch check when appropriate."
      },
      {
        "id": "mw-test-improve-gate",
        "type": "completion_gate",
        "incomplete_title": "One clue left",
        "complete_title": "Your evidence is saved",
        "incomplete_prompt": "Choose a change, predict, record, and compare your actual results.",
        "complete_prompt": "Your work is saved. You can continue.",
        "rules": [
          {
            "field": "one_change",
            "condition": "answered"
          },
          {
            "field": "trial_b_prediction",
            "condition": "answered"
          },
          {
            "field": "car_trial_b",
            "condition": "record_complete"
          },
          {
            "field": "trial_comparison",
            "condition": "answered"
          }
        ]
      }
    ]
  },
  "magnetworks-explain": {
    "step_id": "magnetworks-explain",
    "title": "Why Did Pip Move Two Ways?",
    "subtitle": "Explain your evidence before watching the science movie.",
    "phase": "Explain",
    "story": "Child explanation first; media and PWO reveal hidden forces afterward.",
    "age_band": "explorers_5_7",
    "self_guided": {
      "title": "Why Did Pip Move Two Ways?",
      "say": "Tell Pip what your tests suggested. Then watch the science clue and explore the 3D field pattern.",
      "do_now": "Choose your own explanation first. Next watch the movie, open the 3D model, and compare those clues with YOUR reports.",
      "help_prompt": "Professor Swan: You are the calm, capable master teacher helping a 5–7-year-old investigate the REAL Learning Resources Magnetworks LER9468 (manufacturer 5+). Pip is the wheeled green car. Use the exact current activity and child's saved answers. One short spoken instruction or one diagnostic question at a time. The child must predict and report physical results; do not infer that Pip moved from a checkbox, picture, animation, or prior adult experiment. Treat 'stayed still', 'not sure', and 'stopped' as valid evidence. No fixed magnet-disc color means north or south. Keep the wall upright; car travels along one side of barrier, not through the cardboard. Where magnets are safely arranged, reversing the facing pole can change attraction/repulsion and motion direction, but actual results also depend on placement and friction. Before the child offers their own explanation, don't spoil the pole-direction discovery. Never demand that a 5-year-old loosen or swap small detachable magnets independently. Specific safety: this kit contains a small magnetic ball, small parts and detachable magnets; no mouthing, nose/ear use, or exposure to under-3 siblings; stop if a magnet is damaged or missing; adult handles small loose discs for car setup/reorientation and levitation. Avoid repetitive generic adult supervision. PWO 449 shows iron filings as a representation of field patterns, not a force-producing material. Optional PWO 450 is a *new* electromagnetism/motor topic; initial current slider is 0 mA, so ask child to move slider a little above zero to see motion, then back to zero. No motor or batteries in this physical Magnetworks kit.",
      "transition_summary": "You compared your own idea with a science example and a 3D model.",
      "next_preview": "Another mystery is ready when you are.",
      "materials": [
        "Learning Resources STEM Explorers Magnetworks LER9468, age 5+",
        "Green magnetic wand and colored magnetic chips",
        "Green magnetic ball and thin, flat cardboard (optional maze)",
        "Green wheeled car, blue top, three disc magnets and supplied brick-pattern barrier card",
        "Purple magnetic stand and disc magnets (Grow)",
        "Flat clear tabletop and broad start/home markers"
      ],
      "parent_note": "The child leads thinking and tests. Help with loose magnets and cardboard cutting, and follow the manufacturer's warnings.",
      "caregiver_safety": [
        "Small magnetic ball, chips, and removable disc magnets are choking/ingestion hazards. Keep away from mouths, ears, noses and children under 3; account for all pieces after play.",
        "Do not use damaged/cracked magnets. If a magnet is swallowed or inhaled, seek urgent medical care; do not wait for symptoms.",
        "A grown-up prepares cardboard cutting and manages loose disc insertion, face changes or levitation stacking if needed. The child makes the predictions, uses the assembled wand, and reports observations."
      ]
    },
    "blocks": [
      {
        "id": "mw-evidence-a-b",
        "type": "prior_work_summary",
        "title": "Your reports from Pip’s rescue",
        "items": [
          {
            "source_step_id": "magnetworks-apply",
            "field": "car_trial_a",
            "label": "Trial 1"
          },
          {
            "source_step_id": "magnetworks-test-improve",
            "field": "one_change",
            "label": "One change"
          },
          {
            "source_step_id": "magnetworks-test-improve",
            "field": "car_trial_b",
            "label": "Trial 2"
          }
        ]
      },
      {
        "id": "mw-first-explanation",
        "type": "choice_cards",
        "title": "What is YOUR explanation?",
        "prompt": "Before the science movie, choose the idea that best fits what you observed. It is fine if the tests did not work.",
        "save_as": "explanation_before_media",
        "required": true,
        "choices": [
          {
            "id": "orientation",
            "label": "Turning a magnetic face around may change a push or pull"
          },
          {
            "id": "distance",
            "label": "Changing the space may change how Pip moves"
          },
          {
            "id": "other",
            "label": "My results suggest something else"
          },
          {
            "id": "unknown",
            "label": "I could not tell yet or need more evidence"
          }
        ],
        "master_teacher_response_kind": "learner_explanation"
      },
      {
        "id": "mw-science-video",
        "type": "local_video",
        "title": "Why Did Pip Move Two Ways?",
        "path": "magnetworks/explain/why_pip_moves_two_ways_v1.mp4",
        "poster": "magnetworks/explain/science_poster.jpg",
        "mission": "You have made your own explanation. Now watch a science story about how magnets CAN attract or repel. Your real Pip may have moved differently or not at all.",
        "master_teacher_watch": {
          "button": "Watch why Pip moved",
          "why": "See one possible explanation for opposite movements; compare it with your own reported results.",
          "after": "The video is an example. What matched your experiments? What was different?"
        }
      },
      {
        "id": "mw-fields-pwo",
        "type": "pwo_asset",
        "title": "Look at a magnetic-field pattern",
        "optional": false,
        "mission": "Open the 3D magnet experiment and tap Play. Watch the iron filings make a pattern near the magnets. They show a field pattern; they do not make the magnetic force. This virtual scene is an example, not a recording of your car.",
        "hidden_context": "Ages 5–7: guide a simple observation of the gap pattern, not equations. This PWO may show north poles facing each other with iron filings; do not suggest poles differ in inherent strength. Not physical evidence of this child’s car. The physical car may have stayed still or no test may have occurred; never claim the PWO proves that the child saw attraction or repulsion. Tell the child to tap Open 3D Exploration and Play, then look at the pattern between the magnets.",
        "asset": {
          "id": "mw-fields-pwo-asset",
          "type": "saras_pwo",
          "asset_ref": {
            "source_pwo_id": 449,
            "scene_name": "mainmenu"
          },
          "content_context": {
            "base_board": "saras",
            "language_id": 1,
            "board_topic_id": 638,
            "source_topic_id": 489
          }
        },
        "master_teacher_watch": {
          "button": "Open 3D Exploration",
          "why": "Watch the filings form a pattern around the two magnets. What do you notice in the gap?"
        }
      },
      {
        "id": "mw-after-media",
        "type": "choice_cards",
        "title": "Would you change your explanation?",
        "prompt": "Think about the science example you watched or the 3D model you opened. Does it change what you think about your own result?",
        "save_as": "after_media_reflection",
        "required": true,
        "choices": [
          {
            "id": "same",
            "label": "My explanation still fits what I saw"
          },
          {
            "id": "change",
            "label": "I have a new idea"
          },
          {
            "id": "unsure",
            "label": "I still have questions"
          }
        ]
      },
      {
        "id": "mw-swan-explain",
        "type": "saras_checkpoint",
        "title": "Discuss your evidence with Swan",
        "suggested_questions": [
          "How do magnetic fields affect two magnets?",
          "Why did my car move differently?"
        ],
        "hidden_context": "Professor Swan: You are the calm, capable master teacher helping a 5–7-year-old investigate the REAL Learning Resources Magnetworks LER9468 (manufacturer 5+). Pip is the wheeled green car. Use the exact current activity and child's saved answers. One short spoken instruction or one diagnostic question at a time. The child must predict and report physical results; do not infer that Pip moved from a checkbox, picture, animation, or prior adult experiment. Treat 'stayed still', 'not sure', and 'stopped' as valid evidence. No fixed magnet-disc color means north or south. Keep the wall upright; car travels along one side of barrier, not through the cardboard. Where magnets are safely arranged, reversing the facing pole can change attraction/repulsion and motion direction, but actual results also depend on placement and friction. Before the child offers their own explanation, don't spoil the pole-direction discovery. Never demand that a 5-year-old loosen or swap small detachable magnets independently. Specific safety: this kit contains a small magnetic ball, small parts and detachable magnets; no mouthing, nose/ear use, or exposure to under-3 siblings; stop if a magnet is damaged or missing; adult handles small loose discs for car setup/reorientation and levitation. Avoid repetitive generic adult supervision. PWO 449 shows iron filings as a representation of field patterns, not a force-producing material. Optional PWO 450 is a *new* electromagnetism/motor topic; initial current slider is 0 mA, so ask child to move slider a little above zero to see motion, then back to zero. No motor or batteries in this physical Magnetworks kit. No equations or claim that PWO 449 proves the real child’s outcome; use the saved first and second trial reports. The video title Why Did Pip Move Two Ways does NOT mean this child observed two directions. Before discussing the video or PWO, check car_trial_a and car_trial_b including not_tested and still. Do not claim the child opened media without a report."
      },
      {
        "id": "mw-explain-gate",
        "type": "completion_gate",
        "incomplete_title": "One clue left",
        "complete_title": "Your evidence is saved",
        "incomplete_prompt": "Explain from your evidence and compare it with the science clues.",
        "complete_prompt": "Your work is saved. You can continue.",
        "rules": [
          {
            "field": "explanation_before_media",
            "condition": "answered"
          },
          {
            "field": "after_media_reflection",
            "condition": "answered"
          }
        ]
      }
    ]
  },
  "magnetworks-reflect": {
    "step_id": "magnetworks-reflect",
    "title": "What Did You Figure Out?",
    "subtitle": "Compare your first guess with what you saw.",
    "phase": "Reflect",
    "story": "Celebrate evidence and persistence, not a scripted success.",
    "age_band": "explorers_5_7",
    "self_guided": {
      "title": "What Did You Figure Out?",
      "say": "Compare your first guess with what you reported from the experiments.",
      "do_now": "Look at your first prediction and your real reports. Choose how your thinking changed.",
      "help_prompt": "Professor Swan: You are the calm, capable master teacher helping a 5–7-year-old investigate the REAL Learning Resources Magnetworks LER9468 (manufacturer 5+). Pip is the wheeled green car. Use the exact current activity and child's saved answers. One short spoken instruction or one diagnostic question at a time. The child must predict and report physical results; do not infer that Pip moved from a checkbox, picture, animation, or prior adult experiment. Treat 'stayed still', 'not sure', and 'stopped' as valid evidence. No fixed magnet-disc color means north or south. Keep the wall upright; car travels along one side of barrier, not through the cardboard. Where magnets are safely arranged, reversing the facing pole can change attraction/repulsion and motion direction, but actual results also depend on placement and friction. Before the child offers their own explanation, don't spoil the pole-direction discovery. Never demand that a 5-year-old loosen or swap small detachable magnets independently. Specific safety: this kit contains a small magnetic ball, small parts and detachable magnets; no mouthing, nose/ear use, or exposure to under-3 siblings; stop if a magnet is damaged or missing; adult handles small loose discs for car setup/reorientation and levitation. Avoid repetitive generic adult supervision. PWO 449 shows iron filings as a representation of field patterns, not a force-producing material. Optional PWO 450 is a *new* electromagnetism/motor topic; initial current slider is 0 mA, so ask child to move slider a little above zero to see motion, then back to zero. No motor or batteries in this physical Magnetworks kit.",
      "transition_summary": "You considered how your thinking changed and what you would investigate next.",
      "next_preview": "Another mystery is ready when you are.",
      "materials": [
        "Learning Resources STEM Explorers Magnetworks LER9468, age 5+",
        "Green magnetic wand and colored magnetic chips",
        "Green magnetic ball and thin, flat cardboard (optional maze)",
        "Green wheeled car, blue top, three disc magnets and supplied brick-pattern barrier card",
        "Purple magnetic stand and disc magnets (Grow)",
        "Flat clear tabletop and broad start/home markers"
      ],
      "parent_note": "The child leads thinking and tests. Help with loose magnets and cardboard cutting, and follow the manufacturer's warnings.",
      "caregiver_safety": [
        "Small magnetic ball, chips, and removable disc magnets are choking/ingestion hazards. Keep away from mouths, ears, noses and children under 3; account for all pieces after play.",
        "Do not use damaged/cracked magnets. If a magnet is swallowed or inhaled, seek urgent medical care; do not wait for symptoms.",
        "A grown-up prepares cardboard cutting and manages loose disc insertion, face changes or levitation stacking if needed. The child makes the predictions, uses the assembled wand, and reports observations."
      ]
    },
    "blocks": [
      {
        "id": "mw-original-prediction",
        "type": "prior_work_summary",
        "title": "Your first idea",
        "items": [
          {
            "source_step_id": "magnetworks-wonder",
            "field": "first_idea",
            "label": "My first idea"
          },
          {
            "source_step_id": "magnetworks-wonder",
            "field": "first_prediction",
            "label": "My prediction"
          },
          {
            "source_step_id": "magnetworks-apply",
            "field": "car_trial_a",
            "label": "The first car test"
          },
          {
            "source_step_id": "magnetworks-test-improve",
            "field": "car_trial_b",
            "label": "The second car test"
          }
        ]
      },
      {
        "id": "mw-reflection",
        "type": "choice_cards",
        "title": "What happened to your first idea?",
        "prompt": "Look at the first guess and your test reports. There is no right or wrong starting guess. Which choice matches your experience?",
        "save_as": "reflection",
        "required": true,
        "choices": [
          {
            "id": "worked",
            "label": "My first idea matched some results"
          },
          {
            "id": "changed",
            "label": "I changed my idea after testing"
          },
          {
            "id": "surprise",
            "label": "Something surprised me"
          },
          {
            "id": "more",
            "label": "I still have a question"
          }
        ]
      },
      {
        "id": "mw-science-habit",
        "type": "choice_cards",
        "title": "What helped you investigate?",
        "prompt": "Which scientist move did you really use today? You can still be curious if a test did not work.",
        "save_as": "science_habit",
        "required": true,
        "choices": [
          {
            "id": "look",
            "label": "I looked carefully"
          },
          {
            "id": "predict",
            "label": "I made a prediction"
          },
          {
            "id": "one",
            "label": "I tried to change just one thing"
          },
          {
            "id": "help",
            "label": "I asked a useful question"
          }
        ]
      },
      {
        "id": "mw-swan-reflect",
        "type": "saras_checkpoint",
        "title": "Tell Swan what changed",
        "suggested_questions": [
          "Which test surprised me?",
          "What would I do differently?"
        ],
        "hidden_context": "Professor Swan: You are the calm, capable master teacher helping a 5–7-year-old investigate the REAL Learning Resources Magnetworks LER9468 (manufacturer 5+). Pip is the wheeled green car. Use the exact current activity and child's saved answers. One short spoken instruction or one diagnostic question at a time. The child must predict and report physical results; do not infer that Pip moved from a checkbox, picture, animation, or prior adult experiment. Treat 'stayed still', 'not sure', and 'stopped' as valid evidence. No fixed magnet-disc color means north or south. Keep the wall upright; car travels along one side of barrier, not through the cardboard. Where magnets are safely arranged, reversing the facing pole can change attraction/repulsion and motion direction, but actual results also depend on placement and friction. Before the child offers their own explanation, don't spoil the pole-direction discovery. Never demand that a 5-year-old loosen or swap small detachable magnets independently. Specific safety: this kit contains a small magnetic ball, small parts and detachable magnets; no mouthing, nose/ear use, or exposure to under-3 siblings; stop if a magnet is damaged or missing; adult handles small loose discs for car setup/reorientation and levitation. Avoid repetitive generic adult supervision. PWO 449 shows iron filings as a representation of field patterns, not a force-producing material. Optional PWO 450 is a *new* electromagnetism/motor topic; initial current slider is 0 mA, so ask child to move slider a little above zero to see motion, then back to zero. No motor or batteries in this physical Magnetworks kit. Praise evidence, not invented success. Give evidence-specific recap using saved guesses and reports only; do not automatically say the child succeeded or reversed a car. If an attempt was not tested, acknowledge the safe stop and ask one next-investigation question. Do not substitute generic praise."
      },
      {
        "id": "mw-reflect-gate",
        "type": "completion_gate",
        "incomplete_title": "One clue left",
        "complete_title": "Your evidence is saved",
        "incomplete_prompt": "Choose how your thinking changed and what you did as a scientist.",
        "complete_prompt": "Your work is saved. You can continue.",
        "rules": [
          {
            "field": "reflection",
            "condition": "answered"
          },
          {
            "field": "science_habit",
            "condition": "answered"
          }
        ]
      }
    ]
  },
  "magnetworks-grow": {
    "step_id": "magnetworks-grow",
    "title": "The Floating Rescue Signal",
    "subtitle": "Can magnetic discs appear to float without touching?",
    "phase": "Grow",
    "story": "A new mystery using repulsion on a guiding post.",
    "age_band": "explorers_5_7",
    "self_guided": {
      "title": "The Floating Rescue Signal",
      "say": "New mystery! We are leaving the car for now. Find the purple stand and ring-shaped magnets. First, make a guess—then try them.",
      "do_now": "New adventure: find the purple stand and two disc magnets. Guess first, then stack and report. The motor model is optional.",
      "help_prompt": "Professor Swan: You are the calm, capable master teacher helping a 5–7-year-old investigate the REAL Learning Resources Magnetworks LER9468 (manufacturer 5+). Pip is the wheeled green car. Use the exact current activity and child's saved answers. One short spoken instruction or one diagnostic question at a time. The child must predict and report physical results; do not infer that Pip moved from a checkbox, picture, animation, or prior adult experiment. Treat 'stayed still', 'not sure', and 'stopped' as valid evidence. No fixed magnet-disc color means north or south. Keep the wall upright; car travels along one side of barrier, not through the cardboard. Where magnets are safely arranged, reversing the facing pole can change attraction/repulsion and motion direction, but actual results also depend on placement and friction. Before the child offers their own explanation, don't spoil the pole-direction discovery. Never demand that a 5-year-old loosen or swap small detachable magnets independently. Specific safety: this kit contains a small magnetic ball, small parts and detachable magnets; no mouthing, nose/ear use, or exposure to under-3 siblings; stop if a magnet is damaged or missing; adult handles small loose discs for car setup/reorientation and levitation. Avoid repetitive generic adult supervision. PWO 449 shows iron filings as a representation of field patterns, not a force-producing material. Optional PWO 450 is a *new* electromagnetism/motor topic; initial current slider is 0 mA, so ask child to move slider a little above zero to see motion, then back to zero. No motor or batteries in this physical Magnetworks kit.",
      "transition_summary": "You investigated or recorded a safe stop for a new magnetic mystery.",
      "next_preview": "Another mystery is ready when you are.",
      "materials": [
        "Learning Resources STEM Explorers Magnetworks LER9468, age 5+",
        "Green magnetic wand and colored magnetic chips",
        "Green magnetic ball and thin, flat cardboard (optional maze)",
        "Green wheeled car, blue top, three disc magnets and supplied brick-pattern barrier card",
        "Purple magnetic stand and disc magnets (Grow)",
        "Flat clear tabletop and broad start/home markers"
      ],
      "parent_note": "The child leads thinking and tests. Help with loose magnets and cardboard cutting, and follow the manufacturer's warnings.",
      "caregiver_safety": [
        "Small magnetic ball, chips, and removable disc magnets are choking/ingestion hazards. Keep away from mouths, ears, noses and children under 3; account for all pieces after play.",
        "Do not use damaged/cracked magnets. If a magnet is swallowed or inhaled, seek urgent medical care; do not wait for symptoms.",
        "A grown-up prepares cardboard cutting and manages loose disc insertion, face changes or levitation stacking if needed. The child makes the predictions, uses the assembled wand, and reports observations."
      ]
    },
    "blocks": [
      {
        "id": "mw-floating-story",
        "type": "story_hook",
        "title": "NEW MYSTERY — Floating magnets!",
        "body": "We are finished with the car challenge for now. This is a NEW experiment with different pieces: the purple stand and two round magnets. You have not tried floating them yet. First look, then guess. Keep loose magnets away from mouths.",
        "master_teacher_briefing": {
          "title": "New challenge: can magnets float?",
          "steps": [
            "Put Pip’s car and the brick wall aside. We are starting a DIFFERENT mystery.",
            "Find your purple stand and two colored disc magnets. Look at them in the kit photograph below—do not stack them yet.",
            "Guess: will one disc stay above the other with a gap, or will they touch? Choose a prediction. We will test in the NEXT part."
          ],
          "spoken": "New mystery! We are leaving Pip’s car and wall behind for now. Find the purple stand and two round magnets. Look at the picture. Don't stack them yet! First, make a guess: will one disc float above the other, or will they touch? Then we will test."
        }
      },
      {
        "id": "mw-float-intro-photo",
        "type": "image_gallery",
        "title": "Meet the NEW pieces",
        "prompt": "This is the purple stand with a disc resting near its base. It does not tell us what will happen with two discs. What is your guess?",
        "images": [
          {
            "id": "stand-preview",
            "label": "Purple stand and first disc — before our test",
            "path": "magnetworks/references/IMG_4743.jpg",
            "alt": "Real purple magnetic-disc stand with a single orange and blue disc resting near its base"
          }
        ]
      },
      {
        "id": "mw-float-prediction",
        "type": "choice_cards",
        "title": "Will the top disc float?",
        "prompt": "This is ONLY a guess—we have not tested the discs yet. When you place a second disc above the first on the purple post, do you think they will stay apart or touch?",
        "save_as": "float_prediction",
        "required": true,
        "choices": [
          {
            "id": "float",
            "label": "It may stay up with a gap"
          },
          {
            "id": "rest",
            "label": "It may rest on the lower disc"
          },
          {
            "id": "unsure",
            "label": "I am not sure"
          }
        ],
        "master_teacher_response_kind": "prediction"
      },
      {
        "id": "mw-float-trial",
        "type": "experiment_record",
        "title": "Try the floating discs",
        "prompt": "Follow these big steps FIRST. Then tell Swan if the discs floated, touched or could not be tested.",
        "save_as": "float_trial",
        "master_teacher_response_kind": "reported_trial_result",
        "master_teacher_briefing": {
          "title": "Try the floating-disc mystery",
          "steps": [
            "Put the purple stand upright on a flat table. Gently slide one colored disc onto the post.",
            "Slide a second disc down the post. If the discs touch, turn the top disc over with help if needed and try again.",
            "Look at the space between the discs. Is there a gap, are they touching, or did you stop the test? Then report what you saw."
          ],
          "spoken": "Now try the floating discs. Put the purple stand on the table. Slide on one disc, then a second disc. If they touch, get help turning the top disc over. Look for a gap, then tell me what happened."
        },
        "fields": [
          {
            "id": "result",
            "type": "choice",
            "label": "What did you see?",
            "choices": [
              {
                "id": "floating",
                "label": "A gap appeared between discs"
              },
              {
                "id": "touch",
                "label": "The discs touched"
              },
              {
                "id": "tilt",
                "label": "A disc tipped or jumped"
              },
              {
                "id": "not_tested",
                "label": "We could not safely test"
              }
            ]
          }
        ]
      },
      {
        "id": "mw-float-photos",
        "type": "image_gallery",
        "title": "Compare with a real kit photograph",
        "prompt": "Here is how the discs looked in one earlier kit experiment. Compare it with YOUR observation; your result may be different.",
        "images": [
          {
            "id": "stand",
            "label": "Purple stand with one disc",
            "path": "magnetworks/references/IMG_4743.jpg",
            "alt": "Real purple magnetic stand with one colored disc placed near the base"
          },
          {
            "id": "stack",
            "label": "Disc stack with visible gaps",
            "path": "magnetworks/references/IMG_4745.jpg",
            "alt": "Real colored magnetic ring discs on purple post with space between groups of discs"
          }
        ]
      },
      {
        "id": "mw-floating-link",
        "type": "choice_cards",
        "title": "What could hold a disc apart?",
        "prompt": "Use your own observation and what you already learned about magnets. Which idea would you investigate?",
        "save_as": "float_link",
        "required": true,
        "choices": [
          {
            "id": "repel",
            "label": "Magnets may push each other without touching"
          },
          {
            "id": "stand",
            "label": "The post guides them while they move apart"
          },
          {
            "id": "more",
            "label": "I need another test"
          },
          {
            "id": "unsure",
            "label": "I am still wondering"
          }
        ]
      },
      {
        "id": "mw-swan-grow",
        "type": "saras_checkpoint",
        "title": "Ask Swan about floating",
        "suggested_questions": [
          "Why is there a gap?",
          "Does the purple stick make the discs float?"
        ],
        "hidden_context": "Professor Swan: You are the calm, capable master teacher helping a 5–7-year-old investigate the REAL Learning Resources Magnetworks LER9468 (manufacturer 5+). Pip is the wheeled green car. Use the exact current activity and child's saved answers. One short spoken instruction or one diagnostic question at a time. The child must predict and report physical results; do not infer that Pip moved from a checkbox, picture, animation, or prior adult experiment. Treat 'stayed still', 'not sure', and 'stopped' as valid evidence. No fixed magnet-disc color means north or south. Keep the wall upright; car travels along one side of barrier, not through the cardboard. Where magnets are safely arranged, reversing the facing pole can change attraction/repulsion and motion direction, but actual results also depend on placement and friction. Before the child offers their own explanation, don't spoil the pole-direction discovery. Never demand that a 5-year-old loosen or swap small detachable magnets independently. Specific safety: this kit contains a small magnetic ball, small parts and detachable magnets; no mouthing, nose/ear use, or exposure to under-3 siblings; stop if a magnet is damaged or missing; adult handles small loose discs for car setup/reorientation and levitation. Avoid repetitive generic adult supervision. PWO 449 shows iron filings as a representation of field patterns, not a force-producing material. Optional PWO 450 is a *new* electromagnetism/motor topic; initial current slider is 0 mA, so ask child to move slider a little above zero to see motion, then back to zero. No motor or batteries in this physical Magnetworks kit. The post guides alignment and magnetic repulsion can help balance gravity. No anti-gravity claims. The child's float_trial can say touch, tilt, or not_tested. The approved founder video/photo is NOT evidence that this child made discs float. Teach that the guide post supports alignment, magnetic repulsion can oppose the downward force of gravity. Offer one simple next test when safe."
      },
      {
        "id": "mw-grow-gate",
        "type": "completion_gate",
        "incomplete_title": "One clue left",
        "complete_title": "Your evidence is saved",
        "incomplete_prompt": "Predict, report your real float test, and share one possible explanation.",
        "complete_prompt": "Your work is saved. You can continue.",
        "rules": [
          {
            "field": "float_prediction",
            "condition": "answered"
          },
          {
            "field": "float_trial",
            "condition": "record_complete"
          },
          {
            "field": "float_link",
            "condition": "answered"
          }
        ]
      },
      {
        "id": "mw-bonus-motor-story",
        "type": "story_hook",
        "title": "Bonus: Magnets can help motors move",
        "body": "Want one EXTRA mystery? This 3D electric motor uses electricity as well as magnets. Your physical Magnetworks kit needs no batteries. You can finish your Journey without opening this model."
      },
      {
        "id": "mw-motor-pwo",
        "type": "pwo_asset",
        "title": "Optional: Electric Motor",
        "optional": true,
        "mission": "EXTRA 3D adventure, not part of your physical kit. Tap Open 3D Exploration. Find Current (mA) near the top right: it starts at Current = 0 mA, so the motor may not move. Slide it a little above 0, watch what changes, then return it to 0. You do not need to open this model to finish.",
        "hidden_context": "Explain 0 mA starts still; coach one step: move Current slider slightly right from zero. Do not confuse permanent-magnet repulsion with a current-carrying motor. This optional model is not a required physical kit action. When opened, prompt: find Current in top right, slide from 0 to a small positive value. Return to 0 and compare. Do not imply that the motor was operated unless the child reports it.",
        "asset": {
          "id": "mw-motor-pwo-asset",
          "type": "saras_pwo",
          "asset_ref": {
            "source_pwo_id": 450,
            "scene_name": "mainmenu"
          },
          "content_context": {
            "base_board": "saras",
            "language_id": 1,
            "board_topic_id": 641,
            "source_topic_id": 492
          }
        },
        "master_teacher_watch": {
          "button": "Open 3D Exploration",
          "why": "The Current slider begins at zero. Try moving it a little above zero to see what changes."
        }
      },
      {
        "id": "mw-next-adventure",
        "type": "choice_cards",
        "title": "Want another mystery someday?",
        "prompt": "You can finish your adventure now. If you want, choose something fun to investigate next time.",
        "save_as": "bonus_choice",
        "required": false,
        "choices": [
          {
            "id": "maze",
            "label": "Invent a new cardboard maze"
          },
          {
            "id": "motor",
            "label": "Explore the electric motor"
          },
          {
            "id": "again",
            "label": "Try the floating discs again"
          },
          {
            "id": "later",
            "label": "I am ready to finish for today"
          }
        ]
      }
    ]
  }
};
export const getMagnetworksMissionPage = (stepId) => MAGNETWORKS_PAGES[String(stepId || "")] || null;
export default MAGNETWORKS_PAGES;
